import { render, staticRenderFns } from "./moreSstoreGoodsDetail.vue?vue&type=template&id=8c5c713c&scoped=true&lang=html&"
import script from "./moreSstoreGoodsDetail.js?vue&type=script&lang=js&"
export * from "./moreSstoreGoodsDetail.js?vue&type=script&lang=js&"
import style0 from "./goodsDetail.styl?vue&type=style&index=0&id=8c5c713c&lang=stylus&scoped=true&"
import style1 from "./moreSstoreGoodsDetail.styl?vue&type=style&index=1&id=8c5c713c&lang=stylus&scoped=true&"
import style2 from "./resetvant.styl?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5c713c",
  null
  
)

export default component.exports